import React from "react";
import ReportDetail from "../ReportDetail";
import SooCoolDeliveriesReport from "./SooCoolDeliveriesReport";

const SooCoolDeliveries = () => {
  return (
    <ReportDetail title="soocool_deliveries_report">
      <SooCoolDeliveriesReport />
    </ReportDetail>
  );
};

export default SooCoolDeliveries;
